import http from 'hub-http/clients/apiClient';
import HubHttpBaseClient from 'ExportDialog/apiClients/HubHttpBaseClient';
const ExportClient = () => Object.assign({}, HubHttpBaseClient, {
  export: ({
    format,
    knowledgeBaseId
  }) => {
    const data = {
      format
    };
    if (knowledgeBaseId) {
      data.contentGroupIds = [knowledgeBaseId];
    }
    return http.post(`/content-export/v1/content-export/knowledge-base`, {
      data
    });
  }
});
export default ExportClient;